import script from "./ow-clients-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-clients-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-clients-form.vue?vue&type=style&index=0&id=4d04a330&lang=scss"
import "./ow-clients-form.vue?vue&type=style&index=1&id=4d04a330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d04a330"]])

export default __exports__